import { AppHelper } from '../../helpers/AppHelper'
import { Controller } from '../Controller'

export class RoleHelper {

  getAppUser() {
    return Controller.get().userMgr().getAppUser()
  }

  canEditOrg() {
    return this.isOrgSU() || this.isProductSU()
  }

  isProductSU() {
    return Controller.get().userMgr().isProductSU()
  }

  isOrgSU() {
    return this.checkOrgAndRoleMatch(this.getOrgId(), 'SUPERUSER')
  }

  isPartnerSU() {
    return this.checkGroupAndRole('p', 'SUPERUSER')
  }

  hasProductRole(role) {
    return Controller.get().userMgr().hasOrgRole('PRODUCT', role)
  }

  hasOrgRole(orgUnitId, role) {
    return Controller.get().userMgr().hasOrgRole(orgUnitId, role)
  }

  hasCurrentOrgRole(role) {
    return Controller.get().userMgr().hasOrgRole(this.getOrgUnitId(), role)
  }

  getSelectedOrgId() {
    const orgInfoStr = localStorage.getItem('orgInfo')
    if(orgInfoStr) {
      const orgInfo = JSON.parse(orgInfoStr)
      return orgInfo.currentOrgId
    } else {
      return null
    }
  }
  getSelectedOrgUnitId() {
    const orgInfoStr = localStorage.getItem('orgInfo')
    if(orgInfoStr) {
      const orgInfo = JSON.parse(orgInfoStr)
      return orgInfo.currentOrgUnitId || null
    } else {
      return null
    }
  }
  getSelectedSubOrgId() {
    const selectedOrgUnitId = this.getSelectedOrgUnitId()
    if (selectedOrgUnitId && selectedOrgUnitId.includes('-')) { return selectedOrgUnitId }
    return ''
  }

  setCurrentOrgInfo(orgId, orgUnitId) {
    if ([orgId, orgUnitId].includes('PRODUCT')) { return }
    const orgInfo = {
      currentOrgId: orgId,
      currentOrgUnitId: orgUnitId,
    }
    localStorage.setItem('orgInfo', JSON.stringify(orgInfo))
  }

  getSelectedRole() {
    return null
  }

  getOrgs() {
    const user = this.getAppUser()
    return user ? user.orgs : []
  }

  getOrgId() {
    const selectedOrgId = AppHelper.parseOrgId(window.location.pathname) || this.getSelectedOrgId()
    if (selectedOrgId) {
      return selectedOrgId
    }
    // Nothing Selected return default orgId
    const orgs = this.getOrgs()
    if (orgs.length) {
      return orgs[0].orgId
    }
    return null
  }
  getOrgUnitId(orgId) {
    const selectedOrgId = orgId || this.getOrgId()
    const selectedOrgUnitId = this.getSelectedOrgUnitId()
    if (selectedOrgId && selectedOrgUnitId && selectedOrgUnitId.startsWith(selectedOrgId)) {
      return selectedOrgUnitId
    }  
    if (selectedOrgId && this.isProductSU()) { 
      return selectedOrgId 
    }
    const orgs = this.getOrgs() || []
    let firstSubOrgId = null
    for (let i = 0; i < orgs.length; ++i) {
      const org = orgs[i]
      if (org.orgId === selectedOrgId) {
        if(!org.subOrgId) {
          return org.orgId
        }
        if (!firstSubOrgId) 
        { 
          firstSubOrgId = org.subOrgId 
        }
      }
    }
    return firstSubOrgId || orgId
  }
  getOrgUnitTitle() {
    const orgId = this.getOrgId()
    if (AppHelper.isTeamsUnifiedView(orgId)) {
      return this.getMainOrgTitle()
    }
    const orgUnitId = this.getOrgUnitId()
    const orgs = this.getOrgs() || []
    for (let i = 0; i < orgs.length; ++i) {
      const org = orgs[i]
      if ((org.subOrgId ? org.subOrgId === orgUnitId : org.orgId === orgUnitId)) {
        return org.title
      }
    }
    return orgUnitId
  }

  getMainOrgTitle(orgId) {
    const mainOrgId = orgId || this.getOrgId()
    const isCurrentOrg = mainOrgId === this.getOrgId()
    const orgUnitId = isCurrentOrg ? this.getOrgUnitId() : null
    const orgs = this.getOrgs() || []
    const trimTitle = (value) => {
      if (value == null || value === '') return ''
      const t = String(value).trim()
      return t || ''
    }

    if (mainOrgId) {
      const main = orgs.find(o => o.orgId === mainOrgId && !o.subOrgId)
      const mainTitle = trimTitle(main && main.title)
      if (mainTitle) return mainTitle
      const tenantOrg = orgs.find(o => o && o.orgId === mainOrgId && o.mainOrgTitle)
      const fromOrg = trimTitle(tenantOrg && tenantOrg.mainOrgTitle)
      if (fromOrg) return fromOrg
      if (isCurrentOrg) {
        const appUser = this.getAppUser()
        const fromUser = trimTitle(appUser && appUser.mainOrgTitle)
        if (fromUser) return fromUser
      }
    }

    if (orgUnitId) {
      for (let i = 0; i < orgs.length; ++i) {
        const org = orgs[i]
        if (org.subOrgId ? org.subOrgId === orgUnitId : org.orgId === orgUnitId) {
          const unitTitle = trimTitle(org.title)
          if (unitTitle) return unitTitle
          break
        }
      }
    }

    const any = orgs.find(o => o && o.orgId === mainOrgId)
    const anyTitle = trimTitle(any && any.title)
    if (anyTitle) return anyTitle
    if (mainOrgId) return mainOrgId
    if (orgUnitId) return orgUnitId
    return ''
  }

  getOrg() {
    let org = null
    const orgs = this.getOrgs()
    const orgUnitId = this.getOrgUnitId()
    for (let i = 0; i < orgs.length; i++) {
      if (orgs[i].orgUnitId === orgUnitId) {
        org = orgs[i]
        break
      }
    }
    return org
  }

  getUserRolesOfOrg() {
    const org = this.getOrg()
    return (org && org.roles) ? org.roles : []
  }

  checkOrg(orgId) {
    return this.getOrgId() === orgId
  }

  checkGroup(groupId) {
    const org = this.getOrg()
    return org && (org.groupId === groupId)
  }

  checkRole(role) {
    const selectedRole = this.getSelectedRole()
    if (selectedRole) {
      return selectedRole === role
    }
    const roles = this.getUserRolesOfOrg()
    for (let i = 0; i < roles.length; i++) {
      if (roles[i] === role) {
        return true
      }
    }
    return false
  }

  checkGroupAndRole(groupId, role) {
    return this.checkGroup(groupId) && this.checkRole(role)
  }

  checkOrgAndRoleMatch(orgId, role) {
    return this.checkOrg(orgId) && this.checkRole(role)
  }
}
